export const useLocalStorage = () => {
  const getStorageItem = (key: string) => {
    return localStorage.getItem(key);
  };

  const setStorageItem = (key: string, value: string) => {
    localStorage.setItem(key, value);
  };

  const removeStorageItem = (key?: string) => {
    key ? localStorage.removeItem(key) : localStorage.clear();
  };
  return { getStorageItem, setStorageItem, removeStorageItem };
};
